import { GridValidRowModel } from "@mui/x-data-grid";
import { useState } from "react";
import { OpView } from "src/assets/icons";
import { Box } from "src/components/MuiGenerals";
import OpIconButton from "src/components/OpIconButton";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { usePermission, useTranslation } from "src/hooks";
import { FeatureCodes } from "src/utils/constant";
import useViewGroupDialog from "../../ContractSweepRecipientGroup/hooks/useViewGroupDialog";
import { GetListRes } from "../types/GetListRes";

const ViewPermission =
  FeatureCodes.assetManagement.ContractSweepRecipentSetting
    .ContractSweepRecipent.viewGroup;

const useOperationCell = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { hasPermission } = usePermission();

  //state of dialog
  const [isViewGroupDialogOpen, setIsViewGroupDialogOpen] = useState(false);

  //state of selected data
  const [selectedRow, setSelectedRow] = useState<
    GridValidRowModel & { rawData: GetListRes }
  >();

  //reuse View group dialog in Recipient Group
  const { renderViewGroupDialog } = useViewGroupDialog({
    isOpen: isViewGroupDialogOpen,
    onClose: () => {
      setIsViewGroupDialogOpen(false);
      setSelectedRow(undefined);
    },
    viewGroupData: {
      chainType: selectedRow?.rawData.chain_type,
      chainId: selectedRow?.rawData.chain_id,
      assetName: selectedRow?.rawData.asset_name,
      groupId: selectedRow?.rawData.group_id,
      groupSequence:
        selectedRow?.rawData.auto_sweep_asset_dest_group?.group_seq,
      groupName: selectedRow?.rawData.auto_sweep_asset_dest_group?.group_name,
      groupType: selectedRow?.rawData.auto_sweep_asset_dest_group?.group_type,
      maximumAmountLimit:
        selectedRow?.rawData.auto_sweep_asset_dest_group?.max_amount_limit,
      rotateAmountLimit:
        selectedRow?.rawData.auto_sweep_asset_dest_group
          ?.rotate_group_amount_limit,
    },
  });

  const renderOperationCell = (params: Params<GetListRes>) => {
    const onViewGroupClick = () => {
      setIsViewGroupDialogOpen(true);
      setSelectedRow(params.row);
    };

    return (
      <Box display={"flex"} flexDirection={"row"} gap={1}>
        {hasPermission(ViewPermission) && (
          <OpIconButton
            title={t("view_group")}
            url={OpView}
            onClick={onViewGroupClick}
          />
        )}
      </Box>
    );
  };

  const renderDialogInOperationCell = () => {
    return <>{renderViewGroupDialog()}</>;
  };

  return {
    renderOperationCell,
    renderDialogInOperationCell,
  };
};
export default useOperationCell;
